import { useMemo } from "react";

import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

import { ModulesSuggestions } from "../../FiltersLayout/constants";
import useCellFilterAction from "../useCellFilterAction";

const ModulesTableProviderCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const providerFilterAction = useCellFilterAction({
    filterName: ModulesSuggestions.ModuleProvider,
    filterValue: module.terraformProvider,
  });

  const actions = useMemo(() => [providerFilterAction], [providerFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellText>{module.terraformProvider}</TableCellText>
    </TableSimpleCell>
  );
};

export default ModulesTableProviderCell;
